// extracted by mini-css-extract-plugin
export var blue = "_43-g";
export var brand = "_43-c";
export var darkGrey = "_43-f";
export var disabled = "_43-5";
export var disabledSubtle = "_43-6";
export var error = "_43-7";
export var green = "_43-h";
export var grey = "_43-e";
export var icon = "_43-0";
export var inherit = "_43-b";
export var lightGrey = "_43-d";
export var orange = "_43-j";
export var pink = "_43-l";
export var primary = "_43-1";
export var purple = "_43-m";
export var quaternary = "_43-4";
export var red = "_43-k";
export var secondary = "_43-2";
export var success = "_43-a";
export var tertiary = "_43-3";
export var warning = "_43-8";
export var warningSecondary = "_43-9";
export var white = "_43-n";
export var yellow = "_43-i";